import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import faqConf from '@/common/store/glb/data.faqs';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import compareRates, { RATETYPES } from '@/staticpages/components/comparerates/comparerates.vue';
import { defineAsyncComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
const mvtRateTrend = defineAsyncComponent(() => import(/* webpackChunkName: "rateTrend" */ '@/common/components/mvtratetrend/mvt-ratetrend.vue'));

export default {
    name: 'pageRefinancerates',
    inject: ['$eventBus'],
    components: {
        mvtDialogCenter,
        mvtHeader,
        compareRates,
        mvtArticle,
        mvtFaq,
        mvtRateTrend,
        mortgageTools,
        mvtFooter,
        mvtLazyload,
    },
    data() {
        return {
            defaultRateType: RATETYPES.REFINANCE,
            tag: null,
            faqQuery: null,
        };
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
    },
    methods: {
        ...mapActions('glb', ['fetchArticleFeeds', 'fetchFAQs']),
    },
    mounted() {
        this.tag = this.glb.articleConfig.tag.mortgageRates;
        this.faqQuery = faqConf.mortgageRefinance;
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
